/**
 * Whether a UserType value represents a direct customer account (as opposed
 * to ADMIN, PBUYER, LENDER, or TITLE). Centralizes the check so call sites
 * don't compare against 'CUSTOMER' directly.
 */
export const isCustomerType = (type?: string | null): boolean => type === 'CUSTOMER';
